import { createMuiTheme } from "@material-ui/core/styles";

const colorPrimary = {
  light: "#BDC5CD",
  main: "#666666",
  dark: "#333333",
  contrastText: "#FFF",
};

const colorSecondary = {
  light: "#FFF",
  main: "#127DA9",
  dark: "#0D5876",
  contrastText: "#FFF",
};

export const theme = createMuiTheme({
  typography: {
    fontFamily: ["Nunito", "sans-serif"].join(","),
    htmlFontSize: 16,
  },

  palette: {
    primary: colorPrimary,
    secondary: colorSecondary,
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        a: {
          color: colorSecondary.main,
          textDecoration: "none",
          fontWeight: 700,
        },
        html: {
          height: "100%",
        },
        body: {
          height: "100%",
          backgroundColor: "#FFF",
        },
        "#root": {
          height: "100%",
        },
      },
    },

    MuiInputBase: {
      input: {
        "@media only screen and (max-width: 600px)": {
          fontSize: "16pt",
        },
      },
    },

    MuiInput: {
      root: {
        color: colorPrimary.main,
        fontSize: ".75rem",
      },
      underline: {
        "&:before": {
          borderBottom: `1px solid ${colorPrimary.main}`,
          opacity: ".3",
        },
        "&:after": {
          borderBottom: `2px solid ${colorSecondary.main}`,
        },
      },
    },

    MuiInputLabel: {
      root: {
        fontSize: ".75rem",
      },
    },

    MuiTextField: {
      root: {
        width: "100%",
      },
    },

    MuiFormLabel: {
      root: {
        "&.Mui-focused": {
          color: colorSecondary.main,
        },
      },
    },

    MuiSelect: {
      select: {
        "&:focus": {
          backgroundColor: colorPrimary.light,
        },
      },
    },

    MuiAppBar: {
      colorPrimary: {
        backgroundColor: colorSecondary.light,
        color: colorPrimary.main,
      },
    },

    MuiLinearProgress: {
      root: {
        borderRadius: 20,
      },

      barColorPrimary: {
        backgroundColor: "#49B581",
      },
    },

    MuiStepper: {
      root: {
        padding: 0,
        backgroundColor: "#F6F7FB",
      },
    },

    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: colorPrimary.main,
      },
    },
    MuiPickersDay: {
      daySelected: {
        backgroundColor: colorPrimary.main,
        "&:hover": {
          backgroundColor: colorPrimary.main,
        },
      },
    },
    MuiButton: {
      root: {
        textTransform: "none",
      },
      text: {
        fontSize: ".75rem",
        color: colorSecondary.main,
        "&:hover": {
          color: colorSecondary.dark,
        },
      },
      contained: {
        backgroundColor: colorSecondary.main,
        color: colorSecondary.contrastText,
        padding: "10px 40px",
        textTransform: "none",
        fontWeight: 500,
        fontSize: "1rem",
        borderRadius: 5,
        minWidth: 125,
        "&:hover": {
          backgroundColor: colorSecondary.dark,
        },
      },
      outlined: {
        borderColor: colorPrimary.main,
        color: colorPrimary.main,
        padding: "10px 40px",
        textTransform: "none",
        fontWeight: 500,
        fontSize: "1rem",
        borderRadius: 5,
        minWidth: 125,
        "&:hover": {
          backgroundColor: colorPrimary.light,
        },
      },
    },
    MuiTabs: {
      indicator: {
        height: 4,
      },
    },
    MuiTab: {
      root: {
        marginRight: 30,
        padding: 0,
        minWidth: 0,
        "@media (min-width: 600px)": {
          padding: 0,
          minWidth: 0,
        },
      },
      wrapper: {
        color: colorPrimary.dark,
        fontWeight: "bold",
      },
    },
    MuiTypography: {
      colorTextSecondary: {
        color: colorSecondary.contrastText,
      },

      h1: {
        fontSize: "3rem",
        fontFamily: "proxima-soft, serif",
        fontWeight: 400,
        color: colorPrimary.dark,
      },
      h2: {
        fontSize: "1rem",
        lineHeight: "1.25rem",
        fontFamily: "proxima-soft, sans-serif",
        fontWeight: 300,
        color: colorPrimary.main,
        letterSpacing: 0.84,
      },
      h3: {
        fontSize: "1rem",
        lineHeight: "1.25rem",
        fontFamily: "proxima-soft, sans-serif",
        fontWeight: 300,
        color: colorPrimary.main,
        letterSpacing: 0.84,
      },
      h5: {
        fontWeight: 700,
      },
      h6: {
        fontWeight: 700,
      },
      body1: {
        fontSize: "1rem",
      },
    },
  },
});
